import { Button } from "@/components/atoms/button";
import { cn, generateTargetFromLink } from "@/lib/utils";
import { MemberShipBannerQuery } from "@/types/generated";
import Image from "next/image";
import Link from "next/link";

/**
 * MemberShipSection component
 * Displays membership banner and button for the hotel, with external link and image.
 * Handles finding the current page and rendering membership info if available.
 */

export default function MemberShipSection(
  props: Readonly<{
    membershipProps: MemberShipBannerQuery;
    className?: string;
  }>,
) {
  const pages = props.membershipProps?.sharedDatasourceGotopassParticularPages;

  if (!Array.isArray(pages)) return <></>;

  const currentPage = pages.find(
    (item) => !!item?.documentId && !!item.membership_banner,
  );

  if (!currentPage?.membership_banner) return <></>;

  const { image, button_text, external_link } = currentPage.membership_banner;

  const imageUrl = image?.[0]?.cloudflare_url || image?.[0]?.url;
  const externalHref =
    external_link?.metadata?.text || external_link?.metadata?.url || "#";

  return (
    <>
      {pages?.[0]?.show_goto_pass_placements && (
        <Link
          target={
            external_link ? generateTargetFromLink(external_link) : "_blank"
          }
          href={externalHref}
          className={cn(
            props.className,
            "m-auto flex w-full max-w-[1100px] flex-col overflow-hidden pt-5 hover:opacity-90 md:flex-row md:rounded-2xl md:pt-0",
          )}
        >
          <div className="relative w-full md:w-[394px] md:flex-shrink-0">
            {imageUrl && (
              <Image
                src={imageUrl}
                alt={image?.[0]?.alternativeText || ""}
                aria-label={image?.[0]?.caption || ""}
                width={394}
                height={185}
                className="h-auto w-full object-contain md:rounded-l-2xl"
              />
            )}
          </div>
          <div className="flex flex-1 items-center justify-center bg-[var(--fill-base-main)] p-2 md:rounded-r-2xl">
            <Button className="text-sm font-[var(--font-medium)] text-[var(--text-gray-base)] hover:bg-transparent active:bg-transparent md:text-[22px] md:font-[var(--font-regular)]">
              {button_text}
            </Button>
          </div>
        </Link>
      )}
    </>
  );
}
